export const fr = {
  nav: {
    home: "Accueil",
    services: "Services",
    fleet: "Flotte",
    pricing: "Tarifs",
    blog: "Blog",
    contact: "Contact",
    book: "Réserver",
    call: "Appeler",
    cities: "Destinations",
  },
  hero: {
    overline: "LUXURY VTC RIVIERA",
    title: "Votre Chauffeur VTC Privé sur la",
    titleAccent: "Côte d'Azur",
    subtitle: "Chauffeur VTC Nice et chauffeur privé sur toute la Côte d'Azur : transferts aéroport Nice, Monaco, Cannes, Saint-Tropez. Tarifs forfaitaires, réservation 24h/24.",
    cta1: "Réserver maintenant",
    cta2: "Demander un devis",
    badge1: "Disponible 24/7",
    badge2: "Chauffeur certifié",
    badge3: "Tarifs transparents",
    clarityOverline: "Chauffeur VTC privé · Nice & Côte d'Azur",
    clarityText: "Transferts aéroport, Monaco, Cannes, Antibes, Saint-Tropez. Prix calculé sur le trajet réel.",
    point1: "Prix au trajet réel",
    point2: "Devis en 2 min",
    point3: "Sans compte obligatoire",
  },
  home: {
    heroOverline: "VTC Éco-Responsable · Nice & Côte d'Azur",
    heroTitle: "VlaDriver VTC — Chauffeur Privé Éco-Responsable sur la Côte d'Azur",
    heroSubtitle: "Profitez d'un confort premium à bord de notre flotte 100% Hybride (Toyota C-HR & Corolla Cross). Tarifs fixes garantis, connus à l'avance.",
    heroBadge: "5,0/5 · Chauffeur le mieux noté sur Google",
    heroCtaPrice: "Voir les tarifs",
    heroCtaBook: "Demander mon tarif fixe",
    pricingOverline: "Forfaits tout inclus",
    pricingTitle: "Tarifs fixes garantis",
    pricingSubtitle: "Le prix est connu à l'avance. Aucune surprise, aucun compteur.",
    pricingAllInc: "Tout inclus",
    pricingOnRequest: "Tarif sur demande",
    pricingNote: "Péage, accueil et bagages inclus. Supplément nuit (23h–6h) et dimanche/fériés : +15%.",
    leadOverline: "Demande de tarif",
    leadTitle: "Demandez votre tarif fixe",
    leadSubtitle: "4 champs suffisent — réponse rapide par téléphone ou WhatsApp.",
    leadName: "Nom & Prénom",
    leadPhone: "Téléphone / WhatsApp",
    leadPickup: "Point de départ",
    leadDestination: "Destination",
    leadSubmit: "Réserver via WhatsApp",
    leadSending: "Envoi...",
    leadSuccessTitle: "Demande envoyée ✓",
    leadSuccessBody: "Merci ! Nous vous recontactons très vite. Vous pouvez finaliser tout de suite sur WhatsApp.",
    leadWhatsapp: "Continuer sur WhatsApp",
    leadError: "Une erreur est survenue. Réessayez ou appelez-nous au +33 7 83 97 73 70.",
    reviewsOverline: "Avis clients",
    reviewsTitle: "5,0/5 sur Google",
    reviewsSubtitle: "Noté 5 étoiles par nos clients sur toute la Côte d'Azur.",
    reviewsCta: "Voir nos avis sur Google",
    waReserve: "Réserver via WhatsApp",
    quickRoutes: "Trajets populaires :",
    widgetTitle: "Réservez votre chauffeur",
    widgetSubtitle: "Entrez votre trajet, le tarif s'affiche, payez en ligne en 1 min.",
    googleContinue: "Continuer avec Google",
    bookDate: "Date",
    bookTime: "Heure",
    bookEmail: "Email",
    priceComputing: "Calcul du tarif…",
    priceLabel: "Votre tarif",
    priceAllInc: "tout inclus",
    priceError: "Impossible de calculer ce trajet. Précisez les adresses.",
    enterTripForPrice: "Entrez le départ et la destination pour voir votre tarif.",
    payNow: "Réserver et Payer",
    payRedirect: "Redirection vers le paiement…",
    paySecure: "Paiement sécurisé · Course confirmée instantanément",
    paymentSoon: "Votre réservation est enregistrée. Le paiement en ligne sera actif très bientôt — nous vous recontactons pour finaliser.",
    payError: "Une erreur est survenue. Réessayez.",
    payChecking: "Vérification du paiement…",
    paySuccessTitle: "Réservation confirmée ✓",
    paySuccessBody: "Votre course est réservée et payée. À très vite !",
    payPendingTitle: "Paiement en cours…",
    payPendingBody: "Nous finalisons votre paiement. Cette page se met à jour automatiquement.",
    payFailedTitle: "Paiement non abouti",
    payFailedBody: "Le paiement n'a pas pu être finalisé. Vous pouvez réessayer.",
    payRetry: "Réessayer",
    orderTime: "Commande passée le",
    parisTime: "(heure de France)",
    paidTime: "Payée le",
    backHome: "Retour à l'accueil",
  },
  booking: {
    title: "Réservation rapide",
    subtitle: "Obtenez votre devis en moins de 2 minutes",
    quoteBadge: "— Demande de devis",
    heading: "Réservez votre trajet",
    subheading: "Devis personnalisé envoyé sous 15 minutes",
    pickup: "Lieu de prise en charge",
    pickupPh: "Aéroport, hôtel, adresse...",
    destination: "Destination",
    destinationPh: "Monaco, Cannes, hôtel...",
    date: "Date",
    time: "Heure",
    passengers: "Passagers",
    luggage: "Bagages",
    name: "Nom complet",
    phone: "Téléphone",
    email: "Email (optionnel)",
    flight: "Numéro de vol (optionnel)",
    vehicle: "Véhicule",
    chrDesc: "Hybride · 4 pax",
    corollaDesc: "Berline · 4 pax",
    message: "Message ou demande spéciale",
    submit: "Confirmer la réservation",
    requestQuote: "Demander un devis",
    confirmBooking: "Confirmer la réservation",
    confirmedTitle: "Réservation confirmée",
    firmPriceLabel: "Prix ferme",
    tollsIncluded: "Prix total, péages inclus",
    confirmedBody: "C'est noté ! Vlad vous contacte très vite pour les derniers détails.",
    confirmedBodyNoPrice: "Votre demande est bien enregistrée. Vlad vous recontacte sous 15 min avec le prix et les détails.",
    signInToQuote: "Se connecter pour demander un devis",
    success: "Réservation envoyée ! Nous vous contactons sous 15 minutes.",
    error: "Erreur. Veuillez réessayer ou nous appeler directement.",
    successTitle: "Demande reçue",
    successBody: "Nous vous envoyons un devis personnalisé sous {{min}}.",
    successNote: "Vous recevrez le tarif dans votre espace personnel — signature électronique requise pour confirmer.",
    successNoteGuest: "Vlad vous confirme le prix et l'heure par téléphone ou email. Aucun compte nécessaire.",
    viewMyRequest: "Voir ma demande",
    newRequest: "Nouvelle demande",
    quoteInfoTitle: "Devis personnalisé",
    quoteInfoBody: "Prix {{fixedPrice}} affiché au trajet réel, réservation confirmée immédiatement.",
    quoteInfoBodyFixed: "ferme",
    quoteInfoNote: "Prix total, péages inclus. Aucun compte nécessaire.",
    estimateBtn: "Estimer le prix",
    estimateLoading: "Calcul en cours…",
    estimateMissing: "Veuillez renseigner le départ et la destination.",
    estimateUnavailable: "Estimation indisponible.",
    estimateNetworkError: "Erreur réseau. Réessayez.",
    estimateHeading: "Prix du trajet",
    estimateTrip: "Trajet",
    estimateDisclaimer: "Prix ferme calculé sur le trajet réel, péages inclus.",
    estimateTollsNote: "Prix total, péages inclus, communiqué dans le devis avant acceptation",
    estimateAirportNote: "Prise en charge aéroport incluse",
    estimateNightNote: "Tarif de nuit (23h – 06h) appliqué",
    estimateIncludedNote: "Accueil pancarte et bagages inclus",
    reminderOptinTitle: "Vous n'avez pas le temps maintenant ?",
    reminderOptinSubtitle: "On vous enverra un rappel de ce devis dans 15 min, directement sur ce téléphone.",
    reminderOptinCta: "Activer",
    reminderActive: "Rappel activé — on vous notifie dans 15 min.",
  },
  services: {
    title: "Nos Services VTC",
    subtitle: "Une flotte premium pour chaque déplacement",
    airport: { title: "Transfert Aéroport Nice", desc: "Accueil personnalisé en zone d'arrivée avec pancarte nominative. Suivi du vol en temps réel." },
    monaco: { title: "Nice ↔ Monaco", desc: "Trajet direct vers la Principauté en moins de 30 minutes. Idéal pour le Grand Prix et événements VIP." },
    cannes: { title: "Nice ↔ Cannes", desc: "Service privilégié pour le Festival, Mipim et galas. Discrétion et ponctualité garanties." },
    business: { title: "Transport Business", desc: "Mise à disposition à l'heure ou à la journée. Roadshows, séminaires, déplacements professionnels." },
    luxury: { title: "Hôtels de luxe", desc: "Partenaire des palaces de la Riviera : Negresco, Carlton, Hermitage, Hôtel de Paris." },
    events: { title: "Mariages & Événements", desc: "Transport élégant pour vos invités. Forfaits personnalisés pour cérémonies et soirées privées." },
    cruise: { title: "Croisières", desc: "Transferts depuis et vers les ports de Nice, Cannes, Villefranche, Monaco." },
    hourly: { title: "Disposition à l'heure", desc: "Chauffeur à votre disposition pour shopping, visites, rendez-vous successifs." },
  },
  pricing: {
    title: "Tarifs Transparents",
    subtitle: "Prix forfaitaires pour les trajets les plus demandés",
    duration: "Durée",
    price: "Prix",
    quote: "Devis personnalisé",
    note: "Tarifs indicatifs TTC pour une berline jusqu'à 4 passagers. Variations possibles selon période et trafic.",
  },
  fleet: {
    title: "Notre Flotte",
    subtitle: "Deux véhicules premium au choix : Toyota C-HR & Toyota Corolla 2026",
    feat1: "Climatisation bi-zone",
    feat2: "Sièges cuir",
    feat3: "Confort premium à bord",
    feat4: "Chargeurs USB",
    feat5: "Bluetooth audio",
    feat6: "Véhicule hybride éco",
  },
  trust: {
    title: "Pourquoi VlaDriver ?",
    stat1: { num: "5+", label: "Années d'expérience" },
    stat2: { num: "10K+", label: "Clients satisfaits" },
    stat3: { num: "4.9/5", label: "Note moyenne" },
    stat4: { num: "24/7", label: "Disponibilité" },
    feat1: "Chauffeur certifié VTC (carte professionnelle)",
    feat2: "Assurance tous risques premium",
    feat3: "Tarifs fixes, sans surprise",
    feat4: "Paiement CB, espèces ou virement",
    feat5: "Multilingue : Français, Anglais, Italien, Roumain",
    feat6: "Annulation gratuite jusqu'à 12h avant",
  },
  testimonials: {
    title: "Ils nous font confiance",
    subtitle: "Avis vérifiés de nos clients",
  },
  faq: {
    title: "Questions Fréquentes",
    subtitle: "Tout ce que vous devez savoir avant de réserver",
  },
  cta: {
    title: "Prêt pour votre prochain trajet ?",
    subtitle: "Réservez en 2 minutes ou appelez-nous directement",
    book: "Réserver en ligne",
    whatsapp: "WhatsApp",
  },
  footer: {
    tagline: "Chauffeur Privé Haut de Gamme — Nice & Côte d'Azur",
    serviceTitle: "Nos Services",
    cityTitle: "Destinations",
    blogTitle: "Blog & Conseils",
    contactTitle: "Contact",
    legal: "Mentions légales",
    privacy: "Politique de confidentialité",
    cgv: "CGV",
    rights: "Tous droits réservés.",
    siret: "SIRET en cours",
    license: "Licence VTC officielle",
  },
  common: {
    readMore: "Lire la suite",
    backHome: "Retour à l'accueil",
    minutes: "min",
    from: "À partir de",
    quote: "Sur devis",
  },
};
